import React, { FC, useRef } from 'react';
import dynamic from 'next/dynamic';
import Box from '@/components/UI/box/Box';
import HostProfileSkeleton from './hostProfile/hostProfileSkeleton/HostProfileSkeleton';
import useIntersection from '@/hooks/useIntersection';
import styles from './HostProfileContainer.module.scss';
const HostProfile = dynamic(() => import('@/components/houses/_reusable/houseInfo/hostProfileContainer/hostProfile/HostProfile'), {
  ssr: false,
  loading: () => <HostProfileSkeleton />
});
type HostProfileContainerProps = {
  hostId: string;
};
const HostProfileContainer: FC<HostProfileContainerProps> = ({
  hostId
}) => {
  const ref = useRef<HTMLElement | null>(null);
  const isVisible = useIntersection(ref, '100px', true);
  return <Box className={styles['host-profile-container']} id="hostProfile" ref={ref} component={'section'} data-sentry-element="Box" data-sentry-component="HostProfileContainer" data-sentry-source-file="HostProfileContainer.tsx">
      {isVisible && <HostProfile hostId={hostId} />}
    </Box>;
};
export default HostProfileContainer;